import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/two-factor/setup")({
  component: () => <Navigate to="/" replace />,
});
